import React, { useImperativeHandle } from 'react'
import LoaderView from '../../actions/loader/View'
import useTimeline from '../../modules/timeline/useTimeline'
import useTimelineFrame from '../../modules/timeline/useTimelineFrame'
import { IQuestionComponentProps, IQuestionComponentRef } from '../types'

const VoidQuestion = React.memo(
  React.forwardRef<IQuestionComponentRef, IQuestionComponentProps>((_props, ref) => {
    useImperativeHandle<IQuestionComponentRef, IQuestionComponentRef>(ref, () => {
      return {
        tryNext() {
          return false
        },
        tryPrev() {
          return false
        }
      }
    }, [])
    const timeline = useTimeline()
    useTimelineFrame(timeline)

    return <LoaderView />
  }),
  () => true
)

VoidQuestion.displayName = 'VoidQuestion'

export default VoidQuestion
